import { Button, ButtonProps } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import { User } from '../../store/types'
import DateFormat from '../../store/types/enums/DateFormat'
import { Vacation } from '../../store/types/utils/VacationTypes'
import { useAppSelector } from '../../store/redux/hooks'
import { getIsAdmin, getIsManagement } from '../../store/redux/reducers/currentUserSlice'

export interface VacationBarProps {
  vacation: Vacation
  cellDate: string
  isSingleDay: boolean
  chosenDate: string | null
  currentUser: User | null
  employeeName: string
  theme: any
  t: (key: string) => string
  isLeader: boolean
  leaderAcknowledgedVacation?: boolean
}

const VacationBar: React.FC<VacationBarProps> = ({
  vacation,
  cellDate,
  chosenDate,
  currentUser,
  employeeName,
  theme,
  t,
  isLeader,
  leaderAcknowledgedVacation,
}) => {
  const isManagement = useAppSelector(getIsManagement)
  const isAdmin = useAppSelector(getIsAdmin)

  const borderColor =
    (isLeader || isManagement || isAdmin) && leaderAcknowledgedVacation !== undefined
      ? leaderAcknowledgedVacation
        ? theme.palette.success.main
        : theme.palette.error.main
      : 'none'

  const vacationStartDate = dayjs(vacation.startDate)
  const vacationEndDate = dayjs(vacation.endDate)

  const isCellInRange = dayjs(cellDate).isBetween(vacationStartDate, vacationEndDate, undefined, '[]')

  if (!isCellInRange) return null

  const isChosenInside = chosenDate && dayjs(chosenDate).isBetween(vacationStartDate, vacationEndDate, undefined, '[]')

  const commonButtonProps: ButtonProps = {
    component: 'button',
    'aria-label':
      t('page.vacationView.vacation') +
      employeeName +
      t('page.vacationView.from') +
      vacationStartDate.format(DateFormat.DayMonthYear) +
      t('page.vacationView.to') +
      vacationEndDate.format(DateFormat.DayMonthYear),
    size: 'small',
    fullWidth: false,
    variant: 'contained',
    style: {
      borderRadius: 25,
      height: '70%',
      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
      borderBottom: borderColor !== 'none' ? `2px solid ${borderColor}` : 'none',
      width: '100%',
      minWidth: '100%',
      maxWidth: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      margin: '0 auto',
    },
    sx: {
      '&.MuiButton-containedPrimary': {
        backgroundColor: chosenDate && !isChosenInside ? 'disabled.main' : 'auto',
        ':hover': {
          backgroundColor: chosenDate && !isChosenInside ? 'disabled.main' : 'auto',
        },
      },
      width: '100%!important',
      minWidth: '100% !important',
      maxWidth: '100% !important',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      fontSize: '0 !important',
    },
  }

  return (
    <Button
      {...commonButtonProps}
      disableRipple
      disableElevation
      style={{
        ...commonButtonProps.style,
      }}
      sx={{
        ...commonButtonProps.sx,
      }}
    />
  )
}

export default VacationBar
